import { useEffect } from "react";
import { debounce } from "lodash";

const usePreventViewport = () => {
  useEffect(() => {
    const updateViewportHeight = debounce(() => {
      const vh = window.visualViewport?.height || window.innerHeight;
      document.documentElement.style.setProperty("--vh", `${vh}px`);
      document.body.style.height = `${vh}px`;
    }, 300);
    updateViewportHeight();
    window.visualViewport.addEventListener("resize", updateViewportHeight);
    window.addEventListener("resize", updateViewportHeight);
    let lastOrientation =
      window.innerWidth > window.innerHeight ? "landscape" : "portrait";
    const checkOrientation = () => {
      const currentOrientation =
        window.innerWidth > window.innerHeight ? "landscape" : "portrait";
      if (currentOrientation !== lastOrientation) {
        lastOrientation = currentOrientation;
        updateViewportHeight();
      }
    };
    if (
      window.screen.orientation &&
      window.screen.orientation.addEventListener
    ) {
      window.screen.orientation.addEventListener("change", checkOrientation);
    } else {
      window.addEventListener("orientationchange", checkOrientation);
      window.addEventListener("resize", checkOrientation);
    }

    return () => {
      window.visualViewport?.removeEventListener(
        "resize",
        updateViewportHeight
      );
      window.removeEventListener("resize", updateViewportHeight);
      if (
        window.screen.orientation &&
        window.screen.orientation.removeEventListener
      ) {
        window.screen.orientation.removeEventListener(
          "change",
          checkOrientation
        );
      } else {
        window.removeEventListener("orientationchange", checkOrientation);
        window.removeEventListener("resize", checkOrientation);
      }
      document.documentElement.style.removeProperty("--vh");
      document.body.style.height = "";
    };
  }, []);
};

export default usePreventViewport;
